import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getERPStoreSalesTaget } from '@/service/erpAPI';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
};

export const fetchERPStoreSalesTaget = createAsyncThunk(
  'erpStoreSalesTaget/fetchERPStoreSalesTaget',
  async ({ query = {} }, { rejectWithValue }) => {
    try {
      const response = await getERPStoreSalesTaget(query);
      return {
        data: response.data,
        query
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取ERP销售业绩目标失败');
    }
  }
);

const erpStoreSalesTagetSlice = createSlice({
  name: 'erpStoreSalesTaget',
  initialState: defaultState,
  reducers: {
    resetERPStoreSalesTagetState: (state) => {
      state.query = {};
      state.data = {};
      state.error = null;
      state.fetching = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchERPStoreSalesTaget.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchERPStoreSalesTaget.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchERPStoreSalesTaget.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
});

export const { resetERPStoreSalesTagetState } = erpStoreSalesTagetSlice.actions;
export default erpStoreSalesTagetSlice.reducer;
